import type { ChatType } from "./slices/createCommunityInboxSlice";
import type { ChatStoreState } from "./types";

export const selectInboxMessages = (state: ChatStoreState) =>
  state.inbox.messages;
export const selectInboxChat =
  (state: ChatStoreState, type: ChatType) => (id: number) =>
    state.inbox[type === "member" ? "memberChats" : "adminChats"].find(
      chat => chat.id === id,
    );
